module.exports = require('./helpers/bundle-url').getBundleURL('5F6Q8') + "logo.c51670a8.svg";